<div class="lti-upgrade-overlay" *ngIf="isUpgrading">
  <div class="lti-upgrade-spinner">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Redirecting to billing portal…</span>
  </div>
</div>

<header class="lti-topbar">
  <a routerLink="/panel/campaigns" class="lti-brand">
    <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">
  </a>

  <nav class="lti-nav">
    <a routerLink="/panel/campaigns" class="lti-nav-btn" routerLinkActive="active">Campaigns</a>
    <a routerLink="{{backurl}}" class="lti-nav-btn" *ngIf="enableBack">
      <mat-icon style="font-size:16px;width:16px;height:16px;line-height:16px;vertical-align:middle">arrow_back</mat-icon>
      Back
    </a>
  </nav>

  <div class="lti-spacer"></div>

  <button class="lti-user-btn" [matMenuTriggerFor]="menu">
    <div class="lti-avatar">{{userName ? userName[0].toUpperCase() : '--'}}</div>
    <span class="lti-user-name">{{userName ?? '--'}}</span>
    <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px">arrow_drop_down</mat-icon>
  </button>

  <mat-menu #menu="matMenu" xPosition="before" overlayPanelClass="lti-user-dropdown">
    <button mat-menu-item routerLink="/panel/account" routerLinkActive="lti-menu-active">
      <mat-icon>dashboard</mat-icon>
      <span>My account</span>
    </button>
    <button *ngIf="plan =='' || plan == 'One Time Starter Plan' || plan == 'Monthly Starter Plan' || plan == 'Yearly Starter Plan';else upgradePlan"
      mat-menu-item routerLink="/panel/pricing" [class.lti-menu-active]="isPricingPage">
      <mat-icon>sell</mat-icon>
      <span>Upgrade plan</span>
    </button>
    <ng-template #upgradePlan>
      <button mat-menu-item (click)="upgradeDowngrade()" [class.lti-menu-active]="isPricingPage">
        <mat-icon>sell</mat-icon>
        <span>Upgrade plan</span>
      </button>
    </ng-template>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon> Log Out
    </button>
  </mat-menu>
</header>
